document.addEventListener('DOMContentLoaded', () => { 
 const wrapper = document.querySelector('ooo-wl-product-page-button');

const iconsList = document.querySelector('.wishlist-block');
if (!iconsList) return;
 
const wishListOn = iconsList.getAttribute('data-true-wishlist');
const wishListOff = iconsList.getAttribute('data-false-wishlist');

if(!wishListOn || !wishListOff) return;

const icon_1 = JSON.parse(wishListOn);
const icon_2 = JSON.parse(wishListOff);
 
   if (!wrapper || !wrapper.shadowRoot) return;
   const btn = wrapper.shadowRoot.querySelector('button.button--fill');
  if (!btn) return;

   function createIcon(iconUrl) {
    const img = document.createElement('img');
    img.src = iconUrl;
    img.style.width = '26px';
    img.style.height = '26px';
    img.style.display = 'block';
    img.classList.add('ooo-wl-button-icon', 'ooo-wl-button-icon--custom');
    return img;
  }

   function updateIcon() {
    const isWishlisted = btn.getAttribute('aria-checked') === 'true';
    
     const existingIcon = btn.querySelector('img.ooo-wl-button-icon--custom');
    if (existingIcon) existingIcon.remove();
    
     const newIcon = createIcon(isWishlisted ? icon_1 : icon_2);
    btn.insertBefore(newIcon, btn.firstChild);
  }

   updateIcon();

  // Watch for changes to aria-checked attribute
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-checked') {
        updateIcon();
      }
    });
  });

  observer.observe(btn, { attributes: true });
 
});